export { default as DefaultPage } from './DefaultPage';
export { default as AdminPage } from './AdminPage';
export { default as DeptPage } from './DeptPage';
export { default as DicnamePage } from './DicnamePage';
export { default as AconfigPage } from './AconfigPage';



// WEBPACK FOOTER //
// ./src/features/admin/index.js